import { render, staticRenderFns } from "./MainServicesInStore.vue?vue&type=template&id=03e7d25a&scoped=true"
import script from "./MainServicesInStore.vue?vue&type=script&lang=js"
export * from "./MainServicesInStore.vue?vue&type=script&lang=js"
import style0 from "./MainServicesInStore.vue?vue&type=style&index=0&id=03e7d25a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e7d25a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e7d25a')) {
      api.createRecord('03e7d25a', component.options)
    } else {
      api.reload('03e7d25a', component.options)
    }
    module.hot.accept("./MainServicesInStore.vue?vue&type=template&id=03e7d25a&scoped=true", function () {
      api.rerender('03e7d25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/MainServicesInStore.vue"
export default component.exports